export default __webpack_public_path__ + "static/media/45l_bag.b72d9721.jpg";